module.exports = __webpack_public_path__ + "static/media/game-full.4d8e19dd.gif";